<script>
import { required, minLength } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';
import Repositories from '@/repositories';
const Allocations = Repositories.get('allocations');
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';

/**
 * Dashboard Component
 */
export default {
  components: {
    Multiselect,
    Tooltip,
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      allocationForm: {
        name: null,
        allocationGroup: null,
      },
    };
  },
  props: {
    allocationGroups: Array,
  },
  methods: {
    submitAllocation() {
      this.$v.allocationForm.$touch();
      if (!this.$v.allocationForm.$invalid) {
        this.isLoading = true;
        this.createAllocation();
      }
    },
    createAllocation() {
      this.isError = false;

      let queryModel = {
        idPublic: null,
        name: this.allocationForm.name,
        allocationGroupIdPublic: this.allocationForm.allocationGroup.idPublic,
        allocationGroupName: this.allocationForm.allocationGroup.name,
      };

      Allocations.create(queryModel)
        .then((response) => {
          let respAllocation = response.data;

          this.allocationForm.name = null;

          this.$v.$reset();

          this.$emit('allocation-added', respAllocation);
          this.isLoading = false;

          this.$nextTick(() => this.$refs.allocationNameRef.focus());
        })
        .catch(() => {
          //RAISEE
          this.isLoading = false;
          this.isError = true;
        });
    },
  },
  validations: {
    allocationForm: {
      name: { required, minLength: minLength(2) },
      allocationGroup: { required },
    },
  },
};
</script>

<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12" xl="3">
        <b-form-group
          :label="$t('general.name')"
          label-for="allocation-name-input"
        >
          <b-form-input
            id="allocation-name-input"
            ref="allocationNameRef"
            :class="{
              'is-invalid': $v.allocationForm.name.$error,
            }"
            @keydown.enter.prevent="submitAllocation"
            v-model="allocationForm.name"
            :placeholder="$t('general.name')"
          >
          </b-form-input>
          <Tooltip :validations="$v.allocationForm.name" />
        </b-form-group>
      </b-col>
      <b-col sm="12" xl="3">
        <b-form-group
          :label="$t('allocations.allocationGroups')"
          label-for="allocation-group-input"
        >
          <multiselect
            id="allocation-group-input"
            :validator="$v.allocationForm.allocationGroup"
            :class="{
              'is-invalid': $v.allocationForm.allocationGroup.$error,
            }"
            v-model="allocationForm.allocationGroup"
            :options="allocationGroups"
            :show-labels="false"
            :searchable="false"
            :label="'name'"
            track-by="idPublic"
            :placeholder="$t('general.pickAValue')"
            ><template v-slot:noOptions>
              {{ $t('general.noResult') }}
            </template></multiselect
          >
          <Tooltip :validations="$v.allocationForm.allocationGroup" />
        </b-form-group>
      </b-col>
      <b-col sm="12" xl="2" class="flex-vertical-align-bottom">
        <div style="margin-bottom: 18px">
          <b-button
            @click="submitAllocation"
            block
            variant="primary"
            :disabled="isLoading"
          >
            <i
              v-if="isLoading"
              class="bx bx-loader-alt bx-spin"
              style="font-size: 1.2em"
            >
            </i>
            <i
              v-else-if="isError"
              class="fas fa-exclamation text-danger"
              style="margin-left: 4px; margin-right: 4px"
            ></i>
            <span v-else>{{ $t('general.add') }}</span>
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
